import React from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ButtonOne from "../../common/normal-button";
import { ColorsConstants } from "../../cssUtils/constants";
import typography from "../../cssUtils/typography";
import TableSearchInput from "../TableSearchInput";
import { formatWithTzLabel } from "../../utils/dateUtils";

const dummyAgents = [
  {
    id: 1,
    name: "Appointment Booking",
    createdOn: "06 Feb 2026, 06:03 PM",
    updatedOn: "06 Feb 2026, 06:03 PM",
    type: "PROMPT",
  },
  {
    id: 2,
    name: "Appointment Booking",
    createdOn: "06 Feb 2026, 06:03 PM",
    updatedOn: "06 Feb 2026, 06:03 PM",
    type: "PROMPT",
  },
  {
    id: 3,
    name: "Customer Support Bot",
    createdOn: "06 Feb 2026, 06:03 PM",
    updatedOn: "06 Feb 2026, 06:03 PM",
    type: "PROMPT",
  },
];

const AgenticAISKills = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [charCount, setCharCount] = React.useState(0);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearchChange = (value) => {
    if (value.length > 50) return;
    setSearchQuery(value);
    setCharCount(value.length);
  };

  // Filter agents based on search query
  const filteredAgents = dummyAgents.filter(agent =>
    agent.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Box sx={{ p: 3, backgroundColor: "#FAFAFA", minHeight: "100vh" }}>
      {/* Top Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          gap: 2,
          width: "100%",
        }}
      >
        {/* Search - takes remaining width */}
        <Box sx={{ flex: 1 }}>
          <TableSearchInput
            searchQuery={searchQuery}
            onSearchChange={(e) => handleSearchChange(e.target.value)}
            charCount={charCount}
            tooltip="Search agents by name"
            placeholder="Search agents..."
          />
        </Box>

        {/* Button - fixed width */}
        <ButtonOne
          variant="contained"
          onClick={() => props.onNavigate("create_new_agent")}
          sx={{
            whiteSpace: "nowrap",
            height: "40px",
            px: 3,
            ...typography.bodyLarge,
          }}
        >
          Create New Agent
        </ButtonOne>
      </Box>

      {/* Cards Section */}
      <Grid container spacing={3}>
        {filteredAgents.map((agent) => (
          <Grid item xs={12} sm={6} md={4} key={agent.id}>
            <Card
              elevation={0}
              sx={{
                borderRadius: "12px",
                boxShadow: "0px 1px 3px 0px #0000001A",
                overflow: "hidden",
                backgroundColor: "#fff",
              }}
            >
              {/* Card Header */}
              <Box
                sx={{
                  backgroundColor: "#F0F5FF",
                  px: 2,
                  py: 1.5,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    ...typography.bodyLarge,
                    fontWeight: 600,
                    color: ColorsConstants.primaryBackgroundColor,
                  }}
                >
                  {agent.name}
                </Typography>

                <IconButton size="small" onClick={handleMenuClick}>
                  <MoreVertIcon fontSize="small" sx={{ color: "#000000" }} />
                </IconButton>
              </Box>

              {/* Card Body */}
              <Box sx={{ p: 2 }}>
                <Typography sx={{ ...typography.bodySmall, color: "#6C7C93", mb: 0.5 }}>
                  Created On
                </Typography>
                <Typography sx={{ ...typography.bodyLarge, color: "#04142F", mb: 2.5 }}>
                  {agent.createdOn}
                </Typography>

                <Typography sx={{ ...typography.bodySmall, color: "#6C7C93", mb: 0.5 }}>
                  Updated On
                </Typography>
                <Typography sx={{ ...typography.bodyLarge, color: "#04142F", mb: 2.5 }}>
                  {formatWithTzLabel(agent.updatedOn)}
                </Typography>

                <Box
                  sx={{
                    borderTop: "1px solid #E2E8F0",
                    pt: 1.5,
                    mt: 1,
                  }}
                >
                  <Typography sx={{ ...typography.bodySmall, color: "#6C7C93", mb: 0.5 }}>
                    Agent Type
                  </Typography>
                  <Typography
                    sx={{
                      ...typography.bodyLarge,
                      fontWeight: 600,
                      color: ColorsConstants.primaryBackgroundColor,
                    }}
                  >
                    {agent.type}
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* No results message */}
      {filteredAgents.length === 0 && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <Typography sx={{ ...typography.bodyLarge, color: "#9AA6B8" }}>
            No agents found matching your search.
          </Typography>
        </Box>
      )}

      {/* Menu */}
      <Menu 
        anchorEl={anchorEl} 
        open={Boolean(anchorEl)} 
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            border: "1px solid #DCDFE5",
            borderRadius: "8px",
            minWidth: 140,
            "& .MuiMenuItem-root": {
              ...typography.bodyLarge,
              py: 1,
              px: 2,
              "&:hover": {
                backgroundColor: "#F0F7FF",
              },
            },
          },
        }}
      >
        <MenuItem onClick={handleClose}>Edit</MenuItem>
        <MenuItem onClick={handleClose}>Delete</MenuItem>
      </Menu>
    </Box>
  );
};

export default AgenticAISKills;